export default () => ({
  total: null,
  open: false, 
  slide: 1, 
  maxSlides: null,
  isZoomed: false,
  
  toggle() {
    this.open = !this.open;
    Grebify.noScroll(!this.open); 
  },

  toggleZoom() {
    this.isZoomed = !this.isZoomed
  },

  setSlide(index) {
    this.isZoomed = false;
    this.slide = index

    const images = this.$refs.container.querySelectorAll('.slide');

    images.forEach(image => {
      image.classList.remove('active_image')
      image.classList.add('next_image')
    });

    images[this.slide - 1].classList.add('active_image');
    images[this.slide - 1].classList.remove('next_image');
  },

  switchSlide(newSlide) {
    this.isZoomed = false;
    this.slide += newSlide;

    if (this.slide > this.maxSlides) {
      this.slide = 1;
    } else if (this.slide < 1) {
      this.slide = this.maxSlides;
    }

    const images = this.$refs.container.querySelectorAll('.slide');

    images.forEach(image => {
      image.classList.remove('active_image')
      image.classList.add('next_image')
    });

    images[this.slide - 1].classList.add('active_image');
    images[this.slide - 1].classList.remove('next_image');
  }
});
